import React from 'react';

export const TourGuideParagraph = ({ children }) => (
    <div className='tour-guide__paragraph'>
        {children}
    </div>
);
